/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
import { useIsFocused } from '@react-navigation/native';
import { LinearGradient } from 'expo-linear-gradient';
import React, { useRef } from 'react';
import { Platform, ScrollView } from 'react-native';
import { useHistoryUpcomingMutation, useNationalityQuery } from 'src/common/hooks';
import { useSocketSessionMutation } from 'src/common/hooks/socket/useSocketSessionMutation';
import { useSocketUnselectSeatMutation } from 'src/common/hooks/socket/useSocketUnselectSeatMutation';
import { useNationalityState } from 'src/common/hooks/states/useNationalityState';
import StorageHelper from 'src/common/utils/StorageHelper';
import { RegularText } from 'src/components';
import { Container } from 'src/components/bases/Container';
import { AppColors } from 'src/themes/Colors';
import { device, metrics, pixelScaler } from 'src/themes/Metrics';
import { BannerRunning } from './components/BannerRunning';
import { TravelPanel } from './components/TravelPanel';
import { UpcomingTrip } from './components/UpcomingTrip';

// const RecommandedPanel = React.lazy(() => import('./components/recommend/RecommandedPanel'));

const LoginScreen = () => {
  const { mutate: socketSessionMutate } = useSocketSessionMutation();
  const [focus, setFocus] = React.useState<boolean>(false);
  const { data, isFetched } = useNationalityQuery();
  const { setNationality } = useNationalityState();

  const scrollRef = useRef<any>();
  const { mutate: unselectSeatMutate } = useSocketUnselectSeatMutation();

  const { mutate: upcomingMutate, isLoading: upcomingLoading, data: upcomingData } = useHistoryUpcomingMutation();
  const isFocus = useIsFocused();

  // const { isFetching, data: paymentData, error } = usePaymentListingQuery();
  // const { data: cardList } = useCardQuery();
  // if (isFetched) alert(data?.data.length);
  // useNationalityCacheQuery();

  React.useEffect(() => {
    if (isFetched) {
      setNationality(data);
    }
  }, [isFetched]);

  React.useEffect(() => {
    // window?.nham24?.request('consolelog', { userAppResponse: 'hi' });

    // StorageHelper.clearSocketToken();
    // socketSessionMutate();

    StorageHelper.getSocketTokenExpiration()
      .then(async expiresIn => {
        console.log({ expiresIn });
        if (!expiresIn) {
          socketSessionMutate();
          return;
        }

        const socketChanel = await StorageHelper.getSocketChannel();
        if (socketChanel?.departChannel) {
          unselectSeatMutate({ itemId: socketChanel.departSeatsLabel, channel: socketChanel.departChannel });
        }
        if (socketChanel?.returnChannel) {
          unselectSeatMutate({ itemId: socketChanel.returnSeatsLabel, channel: socketChanel.returnChannel });
        }

        await StorageHelper.clearSocketChannel();

        const remainingTimeInMS = parseInt(expiresIn, 10) - Date.now();
        console.log({ remainingTimeInMS });
        // 3600000ms = 1h
        if (remainingTimeInMS <= 3600000) {
          // refetching token
          StorageHelper.clearSocketToken();
          socketSessionMutate();
        }
      })
      .catch(() => {
        console.log('catch');
        StorageHelper.clearSocketToken();
        socketSessionMutate();
      });
  }, []);

  React.useEffect(() => {
    upcomingMutate();
  }, [isFocus]);

  return (
    <>
      <ScrollView
        ref={scrollRef}
        showsVerticalScrollIndicator={false}
        style={{ flex: 1, backgroundColor: AppColors.border }}
        contentContainerStyle={{
          paddingBottom: metrics.extraHuge + (Platform.OS === 'android' ? (focus ? pixelScaler(280) : 0) : 0),
        }}>
        <Container flex backgroundColor={AppColors.backgroundColor}>
          <BannerRunning />
          {/* {upcomingLoading && (
            <Container width="100%" padding={metrics.large} paddingBottom={0}>
              <Container
                backgroundColor={AppColors.border}
                width={pixelScaler(90)}
                height={pixelScaler(20)}
                borderRadius={metrics.borderRadius}
                marginBottom={metrics.medium}
              />
              <Container
                backgroundColor={AppColors.border}
                width="100%"
                height={pixelScaler(76)}
                borderRadius={metrics.borderRadius}
              />
            </Container>
          )} */}
          {upcomingData?.data?.data.length > 0 && <UpcomingTrip data={upcomingData?.data?.data} />}
          {/* <TimeLine
            fromLocation="hi"
            toLocation="hello"
            transits={[
              {
                address: 'SHV',
                latitude: '10.6345121',
                longitude: '103.5556293',
                location: { id: '2', name: 'Sihanoukvill', slug: 'sihanoukvill', abbreviation: 'shv' },
                sequence: 1,
                stationName: 'Nham24 SHV',
              },
              {
                address: 'SHV',
                latitude: '10.6345121',
                longitude: '103.5556293',
                location: { id: '2', name: 'Sihanoukvill', slug: 'sihanoukvill', abbreviation: 'shv' },
                sequence: 1,
                stationName: 'Nham24 SHV',
              },
              {
                address: 'SHV',
                latitude: '10.6345121',
                longitude: '103.5556293',
                location: { id: '2', name: 'Sihanoukvill', slug: 'sihanoukvill', abbreviation: 'shv' },
                sequence: 1,
                stationName: 'Nham24 SHV',
              },
            ]}
          /> */}
          <Container paddingTop={metrics.large} />
          {upcomingData?.data?.data.length > 0 && (
            <Container paddingBottom={metrics.medium} paddingLeft={metrics.large}>
              <RegularText fontWeight="bold" fontSize="large" textLang="bookAnotherBus" />
            </Container>
          )}
          <TravelPanel
            onFocus={() => {
              setFocus(true);
              setTimeout(() => {
                if (scrollRef.current) scrollRef.current.scrollToEnd({ animated: true });
              }, 100);
            }}
            onBlur={() => {
              setFocus(false);
              // setTimeout(() => {
              //   if (scrollRef.current) scrollRef.current.scrollToTop({ animated: true });
              // }, 100);
            }}
          />
          {/* <Container style={{ zIndex: -99 }}>
            <React.Suspense>
              <RecommandedPanel />
            </React.Suspense>
          </Container> */}
        </Container>
      </ScrollView>
      <LinearGradient
        colors={['rgba(0,0,0,0.75)', 'transparent']}
        style={{
          height: pixelScaler(98),
          width: device.width,
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
      {/* <PromptUserToChangeDateModal returnDate="20-01-2023" onPress={() => {}} /> */}
    </>
  );
};

export default LoginScreen;

// const PromptUserToChangeDateModal = ({ returnDate, onPress }: { returnDate: string; onPress: () => void }) => {
//   return (
//     <ReactNativeModal>
//       <Container padding={metrics.large} borderRadius={metrics.borderRadius} backgroundColor={AppColors.white}>
//         <Container paddingBottom={metrics.large}>
//           <RegularText textAlign="center" fontSize="large" fontWeight="bold">
//             Your return date on {returnDate} is full. please change another date.
//           </RegularText>
//         </Container>
//         <PrimaryButton text="Change date" onPress={onPress} />
//       </Container>
//     </ReactNativeModal>
//   );
// };
